import React, { useState, useMemo, useRef } from "react";
import { dbItem, modsArray2 } from "../../Shared/sharedInterfaces";
import { InnerMapValue2 } from "./calculateFunctions";
import Card from "react-bootstrap/Card";
import "./info.css";
import * as functions from "./overzichtFunctions";
import { getTranslations } from "../../Shared/translations";

interface ControllerData {
  label: string;
  values: Map<string, number>;
}

interface MyProps {
  controllerMap: Map<number, ControllerData> | undefined;
}

const InfoScreen = ({ controllerMap }: MyProps) => {
  const t = getTranslations();

  const keyLabels: Record<string, string> = {
    mods: t.aantalMods,
    adresses: t.aantalAdressen,
    buscons: t.busconsumtion,
  };

  return (
    <>
      <div>
        {t.typeUitvoering} {sessionStorage.getItem("uitvoering")} <br></br>
      </div>
      {Array.from(controllerMap!.entries()).map(
        ([outerKey, { label, values }]) => (
          <Card className="ctds">
            <Card.Body key={outerKey}>
              Controller: {label}
              {Array.from(values.entries()).map(([key, value]) => (
                <div key={key} className="innerctds">
                  <label>{keyLabels[key]}</label>: <label>{value}</label>
                </div>
              ))}
            </Card.Body>
          </Card>
        ),
      )}
    </>
  );
};

export default InfoScreen;

/*

  return (
    <>
      <div>
        Type uitvoering: {sessionStorage.getItem("uitvoering")} <br></br>
      </div>

      {Array.from(controllersMap.entries()).map(([outerKey, innerMap]) => (
        <Card className="ctds">
          <Card.Body key={outerKey}>
            Controller: {outerKey}
            {Array.from(innerMap.entries()).map(([key, value]) => (
              <div key={key} className="innerctds">
                <label>{keyLabels[key]}</label>: <label>{value}</label>
              </div>
            ))}
          </Card.Body>
        </Card>
      ))}
    </>
  );

  */
